import React, { useState, useEffect } from 'react';
import { SearchOutlined, CloseCircleFilled } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

function ElasticSearch(props) {
  const [searchedText, setSearchedText] = useState('');
  const [focused, setFocused] = useState(false);

  const history = useHistory();

  useEffect(() => {
    history.listen((location, action) => {
      let currentUrl = `${location.pathname}${location.search}${location.hash}`;
      if (!focused && !currentUrl.includes('/search')) {
        setSearchedText('');
      }
    });
  }, []);

  const handleChange = (ev) => {
    setSearchedText(ev.target.value.replace(/  +/g, ' '));
  };

  const handleClear = (ev) => {
    ev && ev.stopPropagation();
    setSearchedText('');
  };

  const handleKeyDown = (ev) => {
    if (ev.keyCode === 13) {
      handleSearch();
    }
  };

  function preventSpace(input) {
    if (/^\s/.test(input.value)) input.value = '';
  }

  const handleFocused = () => {
    setFocused(true);
  };

  const handleSearch = () => {
    const query = searchedText.trim();
    if (query !== '') {
      history.push(`/search/${query}`);
    } else {
      return;
    }
  };

  return (
    <div onClick={handleFocused} id='searchBar' className='isMobile'>
      <input
        type='text'
        name='search'
        value={searchedText}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocused}
        onBlur={() => setFocused(false)}
        onInput={(ev) => preventSpace(ev.target)}
        placeholder='Search'
      ></input>
      <SearchOutlined className='searchIcon' onClick={handleSearch} />
      {searchedText !== '' && <CloseCircleFilled className='clearIcon' onClick={handleClear} />}
    </div>
  );
}

export default ElasticSearch;
